import {BV_LOCAL_STORAGE_KEY_PREFIX} from '../constants'

export const bvStorageFeedbackHelpfulnessKey = (contentType, contentId) =>
    `${BV_LOCAL_STORAGE_KEY_PREFIX}${contentType}-${contentId}-feedback-helpfulness`

export const bvStorageFeedbackInappropriateKey = (contentType, contentId) =>
    `${BV_LOCAL_STORAGE_KEY_PREFIX}${contentType}-${contentId}-feedback-inappropriate`

export const localeToBVLocale = (locale) => (locale?.id || locale).replace('-', '_')
